module.exports = __webpack_public_path__ + "static/media/image-top.22bdc2cb.png";